// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WeT3","colMin":"styles_colMin__3aG8F"};